<div class="row animated fadeIn">
  <div class="col-md-12">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h4 class="mb-0">
        <a href="javascript:void(0);" routerLink="/inquiry/inquirylist"><span class="mdi mdi-arrow-left"></span></a>
        Details Inquiry
      </h4>
    </div>

    <div class="card">
      <div class="card-body new-detail-page">
        <ngb-tabset #t="ngbTabset" [(activeId)]="activeTab">
          <ngb-tab id="t9">
            <ng-template ngbTabTitle>
              <div (click)="tabclick('t9')"> Details Inquiry </div>
            </ng-template>
            <ng-template ngbTabContent>
              <form>
                <div class="form-row mt-3 odd">
                  <div class="form-group col-lg-4 col-sm-12 p-1">
                    <div class="row w-100 m-0">
                      <label class="col-sm-4 col col-form-label py-0 px-1">Project Name (Project ID):</label>
                      <div class="col-sm-8 col">
                        <p class="view-value">
                          {{ formdata.ProjectName }} ({{
                          formdata.ProjectNumber
                          }})
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-sm-12 p-1">
                    <div class="row w-100 m-0">
                      <label class="col-sm-4 col col-form-label py-0 px-1">Inquiry Name (Inquiry ID):</label>
                      <div class="col-sm-8 col">
                        <p class="view-value">
                          {{ formdata.InquiryName }} ({{
                          formdata.InquiryNumber
                          }})
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-sm-12 p-1">
                    <div class="row w-100 m-0">
                      <label class="col-sm-4 col col-form-label py-0 px-1">
                        Customer Name:</label>
                      <div class="col-sm-8 col">
                        <p class="view-value">{{ formdata.CustomerName }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row1" *ngIf="isCollapsed" style="width: 100%; display: block">
                  <div class="form-row">
                    <div class="form-group col-lg-4 col-sm-12 p-1">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">
                          MEP Contractor:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">
                            {{ formdata.CompanyName_MEP }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12 p-1">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">Main Contractor:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">
                            {{ formdata.CompanyName_Main }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12 p-1">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">
                          Design Consultant:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">
                            {{ formdata.CompanyName_Design }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-row odd">
                    <div class="form-group col-lg-4 col-sm-12 p-1">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">
                          Supervision Consultant:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">
                            {{ formdata.CompanyName_Super }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12 p-1">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">
                          Stages:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">{{ formdata.StageName }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12 p-1">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">
                          Inquiry Probability:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">{{ formdata.Percentage }}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-lg-4 col-sm-12 p-1">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">Received Date:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">{{ formdata.ReceivedDate }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12 p-1">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">
                          Quotation Engineer:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">
                            {{ formdata.QuotationEngineerName }} ({{
                            formdata.QuotationEmployeeId
                            }})
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12 p-1">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">
                          Sales Engineer:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">
                            {{ formdata.SalesEngineerName }} ({{
                            formdata.SalesEmployeeId
                            }})
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-row odd">
                    <div class="form-group mb-1 col-lg-4 col-sm-12">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">Business Vertical:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">
                            {{ formdata.BusinessVerticalName }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12 p-1">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">Total Quoted Value:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">
                            {{ formdata.TotalPriceWithVat | number : "1.2-2" }}
                            <span *ngIf="formdata.TotalPriceWithVat">({{ formdata.currencyName }})</span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12 p-1">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">Total Reported Value:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">
                            {{ formdata.TotalPriceQARWithVat | number : "1.2-2" }}
                            <span *ngIf="formdata.TotalPriceQARWithVat">(QAR)</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-lg-4 col-sm-12 p-1">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">Quoted Date:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">{{ formdata.QuotedDate }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12 p-1">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">Delivery Period:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">
                            {{ formdata.DeliveryPeriodName }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12 p-1">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">Inco Terms:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">{{ formdata.IncoTermsName }}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-row odd">
                    <div class="form-group col-lg-4 col-sm-12 p-1">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">Application:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">
                            {{ formdata.ApplicationName }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12 p-1">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">Exp. Order Date:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">{{ formdata.ExpOrderDate }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12 p-1">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">Quote Margin %:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">{{ formdata.QuoteMargin }}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-lg-4 col-sm-12 p-1" *ngIf="formdata.LostToCompanyName">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">Lost Company To:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">{{ formdata.LostToCompanyName }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12 p-1" *ngIf="formdata.ReasonName">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">Reason:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">{{ formdata.ReasonName }} <span *ngIf="formdata.LostReason"> -
                              {{formdata.LostReason}}</span></p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12 p-1" *ngIf="formdata.LOIMargin">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">LOI Margin %:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">{{ formdata.LOIMargin }}{{formdata}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12 p-1" *ngIf="formdata.SOMargin">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">SO Margin %:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">{{ formdata.SOMargin }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12 p-1" *ngIf="formdata.RevisionName">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">Revision:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">{{ formdata.RevisionName }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row odd">
                    <div class="form-group col-lg-4 col-sm-12 p-1"
                      *ngIf="formdata.RevisionNote && formdata.RevisionName">
                      <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label py-0 px-1">Revision Note:</label>
                        <div class="col-sm-8 col">
                          <p class="view-value">{{ formdata.RevisionNote }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-auto mt-0 text-right pr-0">
                  <div class="mb-2 mb-md-0 pt-1">
                    <button type="button" class="btn btn-outline-info mr-3 fs-12" (click)="edit(id)"
                      *ngIf="permission.Inquiry_Edit==1 || userRId==1">
                      <span>Edit Inquiry</span>
                    </button>

                    <button type="button" class="btn btn-outline-info fs-12" (click)="openClosefun()">
                      <span *ngIf="!isCollapsed">More</span>
                      <span *ngIf="isCollapsed">Less</span>
                    </button>
                  </div>
                </div>

                <div class="form-row mt-0">
                  <div class="col-md-12 mt-2">
                    <ngb-tabset #t="ngbTabset">
                      <ngb-tab id="t1">
                        <ng-template ngbTabTitle>
                          <div (click)="tabclick2()"> Product </div>
                        </ng-template>
                        <ng-template ngbTabContent>
                          <div class="row my-1">
                            <div class="col-12">
                              <div class="d-flex justify-content-between w-100">
                                <div style="max-width: 250px">
                                  <mat-form-field class="example-full-width pb-0 w-100 form-control-design1"
                                    appearance="fill">
                                    <input #inputField matInput class="text-limit form-control-sm pos-search"
                                      [(ngModel)]="searchword_pro" placeholder="Search"
                                      [ngModelOptions]="{ standalone: true }" (keyup.enter)="ProductapplyFilter()" />
                                    <span class="mdi mdi-magnify mdi-2x cursor-pointer" title="Search" style="
                                        position: absolute;
                                        right: 0;
                                        font-size: 20px;
                                        color: #999;
                                        top: 0;
                                      " (click)="ProductapplyFilter()">
                                    </span>
                                    <span class="position-absolute"
                                      style="top: 50%; right: 7%; transform: translate(-50%, -50%);" title="Clear">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                        class="bi bi-x" viewBox="0 0 16 16" (click)="clearUserData()"
                                        (clearEvent)="searchword_pro=''" *ngIf="searchword_pro">
                                        <path
                                          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                      </svg>
                                    </span>
                                  </mat-form-field>
                                </div>
                                <div class="">
                                  <a *ngIf="TotalProductRecord == 0 && (permission.Inquiry_ManageAction==1 || userRId==1)"
                                    href="javascript:void(0);" (click)="show(formdata.InquiryId)"
                                    class="btn btn-sm btn-light-info" style="min-width: 130px">
                                    <span class="mdi mdi mdi-plus"></span> Add
                                    Product
                                  </a>
                                  <a href="javascript:void(0);" (click)="show(formdata.InquiryId)"
                                    class="ml-2 btn btn-sm btn-light-info" style="min-width: 130px"
                                    *ngIf="TotalProductRecord > 0 && (permission.Inquiry_ManageAction==1 || userRId==1)">
                                    <span class="mdi mdi mdi-pencil"></span> Edit
                                    Product
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="table-responsive">


                            <table class="table" mat-table matSorts [dataSource]="ProductDataSource" matSort
                              [matSortActive]="'name'" [matSortDisableClear]="true" [matSortDirection]="'asc'"
                              [multiTemplateDataRows]="true" (matSortChange)="onProductSortData($event)"
                              aria-hidden="true">
                              <ng-container matColumnDef="BusinessVerticalName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                  style="min-width: 100px; max-width: 200px">
                                  Business Vertical<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort != 'BusinessVerticalName'" /><img src="assets/images/sort_up.png"
                                    alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'BusinessVerticalName'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'BusinessVerticalName'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element">
                                  {{ element["BusinessVerticalName"] }}
                                </td>
                              </ng-container>
                              <ng-container matColumnDef="BusinessCategoryName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                  style="min-width: 100px; max-width: 200px">
                                  Business Category<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort != 'BusinessCategoryName'" /><img src="assets/images/sort_up.png"
                                    alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'BusinessCategoryName'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'BusinessCategoryName'
                                    " />
                                </th>

                                <td mat-cell *matCellDef="let element">
                                  {{ element["BusinessCategoryName"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="ProductBrandName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                  style="min-width: 180px; max-width: 200px">
                                  Brand<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort != 'ProductBrandName'" /><img src="assets/images/sort_up.png"
                                    alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'ProductBrandName'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'ProductBrandName'
                                    " />
                                </th>
                                <mat-header-cell *matHeaderCellDef> Filler header cell </mat-header-cell>
                                <td mat-cell *matCellDef="let element" style="min-width: 180px; max-width: 200px">
                                  {{ element["ProductBrandName"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="Origin">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                  style="min-width: 180px; max-width: 200px">
                                  Origin
                                  <img src="assets/images/sort_both.png" alt="" *ngIf="columnsort != 'Origin'" /><img
                                    src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'Origin'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'Origin'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element" style="min-width: 180px; max-width: 200px">
                                  {{ element["Origin"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="Code">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                  style="min-width: 180px; max-width: 200px">
                                  Model / Item Code
                                  <img src="assets/images/sort_both.png" alt="" *ngIf="columnsort != 'Code'" /><img
                                    src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'Code'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'Code'
                                    " />
                                </th>
                                <mat-header-cell *matHeaderCellDef> Filler header cell </mat-header-cell>
                                <td mat-cell *matCellDef="let element" style="min-width: 180px; max-width: 200px">
                                  {{ element["Code"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="Description">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                  style="min-width: 180px; max-width: 200px">
                                  Product Description
                                  <img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort != 'Description'" /><img src="assets/images/sort_up.png" alt=""
                                    *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'Description'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'Description'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element" style="min-width: 180px; max-width: 200px">
                                  {{ element["Description"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="Specified">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                  style="min-width: 80px; max-width: 100px">
                                  Specified
                                  <img src="assets/images/sort_both.png" alt="" *ngIf="columnsort != 'Specified'" /><img
                                    src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'Specified'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'Specified'
                                    " />
                                </th>
                                <mat-header-cell *matHeaderCellDef> Filler header cell </mat-header-cell>
                                <td mat-cell *matCellDef="let element" style="min-width: 80px; max-width: 100px">
                                  {{ element["SpecifiedName"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="Qty">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  Qty
                                  <img src="assets/images/sort_both.png" *ngIf="columnsort != 'Qty'" alt="" /><img
                                    src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon && !downicon && columnsort == 'Qty'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon && !upicon && columnsort == 'Qty'
                                    " />
                                </th>
                                <mat-header-cell *matHeaderCellDef> Filler header cell </mat-header-cell>
                                <td mat-cell *matCellDef="let element" class="text-right p-1 font-12"
                                  style="max-width: 80px">
                                  {{ element["Qty"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="UnitType">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 70px">
                                  Unit Type
                                  <img src="assets/images/sort_both.png" *ngIf="columnsort != 'UnitType'" alt="" /><img
                                    src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'UnitType'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'UnitType'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element" style="min-width: 70px">
                                  {{ element["UnitTypeName"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="Price">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  Unit Price
                                  <img src="assets/images/sort_both.png" alt="" *ngIf="columnsort != 'Price'" /><img
                                    src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'Price'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'Price'
                                    " />
                                </th>
                                <div matColumnDef="Total">
                                  <td mat-header-cell *matHeaderCellDef [attr.colspan]="10"
                                    class="text-right ali font-w">
                                    Total
                                  </td>
                                </div>
                                <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                  {{ element["Price"] | number : "1.2-2" }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="GrossValue">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  GrossValue
                                  <img src="assets/images/sort_both.png" *ngIf="columnsort != 'GrossValue'"
                                    alt="" /><img src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'GrossValue'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'GrossValue'
                                    " />
                                </th>
                                <div matColumnDef="GrossValue1">
                                  <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                    <span *ngIf="formdata['currencyName'] != 'QAR'">{{t_GrossValue | number : "1.2-2"}}
                                      ({{formdata.currencyName}})<br></span>
                                    <span>{{t_GrossValueQAR | number : "1.2-2"}} (QAR)</span>
                                  </td>
                                </div>
                                <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                  {{ element["GrossValue"] | number : "1.2-2" }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="DiscountPer">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  DISCOUNT RATE %<br> & Amt
                                  <img src="assets/images/sort_both.png" *ngIf="columnsort != 'DiscountPer'"
                                    alt="" /><img src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'DiscountPer'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'DiscountPer'
                                    " />
                                </th>
                                <div matColumnDef="DiscountRate">
                                  <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                    <span *ngIf="formdata['currencyName'] != 'QAR'">{{t_DiscountValue | number :
                                      "1.2-2"}} ({{formdata.currencyName}})<br></span>
                                    <span>{{t_DiscountValueQAR | number : "1.2-2"}} (QAR)</span>
                                  </td>
                                </div>
                                <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                  {{element["DiscountPer"] | number : "1.2-2"}} %<br>{{element["DiscountValue"] | number
                                  : "1.2-2"}}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="TotalPrice">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  TOTAL w/o VAT
                                  <img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort != 'TotalPrice'" /><img src="assets/images/sort_up.png" alt=""
                                    *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'TotalPrice'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'TotalPrice'
                                    " />
                                </th>
                                <div matColumnDef="TotalPrice1">
                                  <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                    <span *ngIf="formdata['currencyName'] != 'QAR'">{{t_Price | number : "1.2-2"}}
                                      ({{formdata.currencyName}})<br></span>
                                    <span>{{t_PriceQAR | number : "1.2-2"}} (QAR)</span>
                                  </td>
                                </div>
                                <td mat-cell *matCellDef="let element" class="text-right p-1 font-12"
                                  style="min-width: 110px">
                                  <span *ngIf="formdata['currencyName'] != 'QAR'">{{element["TotalPrice"] | number :
                                    "1.2-2"}}
                                    ({{formdata.currencyName}})<br></span><span>{{element["TotalPriceQAR"] | number
                                    : "1.2-2"}} (QAR)</span>
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="VatRate">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  Tax Rate %<br> & Amt
                                  <img src="assets/images/sort_both.png" alt="" *ngIf="columnsort != 'VatRate'" /><img
                                    src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'VatRate'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'VatRate'
                                    " />
                                </th>
                                <div matColumnDef="Freight">
                                  <td mat-header-cell *matHeaderCellDef class="p-1 font-12 font-w text-right"
                                    [attr.colspan]="14">
                                    <span>Freight Amount</span>
                                  </td>
                                </div>
                                <div matColumnDef="Vat">
                                  <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                    <span *ngIf="formdata['currencyName'] != 'QAR'">{{t_VatValue | number : "1.2-2"}}
                                      ({{formdata.currencyName}})<br></span>
                                    <span>{{t_VatValueQAR | number : "1.2-2"}} (QAR)</span>
                                  </td>
                                </div>
                                <td mat-cell *matCellDef="let element" class="text-right p-1 font-12"
                                  style="min-width: 95px">
                                  {{element["VatRate"] | number : "1.2-2"}} %<br>{{element["VatValue"] | number :
                                  "1.2-2"}}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="TotalPriceWithVat">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  TOTAL PRICE
                                  <img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort != 'TotalPriceWithVat'" /><img src="assets/images/sort_up.png"
                                    alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'TotalPriceWithVat'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'TotalPriceWithVat'
                                    " />
                                </th>
                                <div matColumnDef="FreightAmount">
                                  <td mat-header-cell *matHeaderCellDef class="p-1 font-12 font-w text-right">
                                    <span *ngIf="formdata['currencyName'] != 'QAR'">{{formdata.FreightAmount | number :
                                      "1.2-2"}}
                                      ({{formdata.currencyName}})<br></span>
                                    <span>{{formdata.FreightAmountQAR | number : "1.2-2"}} (QAR)</span>
                                  </td>
                                </div>
                                <div matColumnDef="TotalPriceVat">
                                  <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                    <span *ngIf="formdata['currencyName'] != 'QAR'">{{t_PriceWithVat +
                                      formdata.FreightAmount | number :
                                      "1.2-2"}} ({{formdata.currencyName}})<br></span>
                                    <span>{{t_PriceQARWithVat + formdata.FreightAmountQAR | number : "1.2-2"}}
                                      (QAR)</span>
                                  </td>
                                </div>
                                <td mat-cell *matCellDef="let element" style="min-width: 110px"
                                  class="text-right p-1 font-12">
                                  <span *ngIf="formdata['currencyName'] != 'QAR'">{{element["TotalPriceWithVat"] |
                                    number : "1.2-2"}}
                                    ({{formdata.currencyName}})<br></span><span>{{element["TotalPriceQARWithVat"] |
                                    number :
                                    "1.2-2"}} (QAR)</span>
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="Competitor">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                  style="min-width: 180px; max-width: 200px">
                                  Competitor
                                  <img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort != 'Competitor'" /><img src="assets/images/sort_up.png" alt=""
                                    *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'Competitor'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'Competitor'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element">
                                  {{ element["Competitor"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="Remark">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                  style="min-width: 180px; max-width: 200px">
                                  Tag / Remark
                                  <img src="assets/images/sort_both.png" alt="" *ngIf="columnsort != 'Remark'" /><img
                                    src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'Remark'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'Remark'
                                    " />
                                </th>
                                <div matColumnDef="FreightRemark">
                                  <td mat-header-cell *matHeaderCellDef class="p-1 font-12 font-w" [attr.colspan]="2">
                                    <span>Freight Remarks :</span><br>
                                    {{formdata.FreightRemark}}
                                  </td>
                                </div>
                                <div matColumnDef="blank">
                                  <td mat-header-cell *matHeaderCellDef class="p-1 font-12 font-w" [attr.colspan]="2">
                                  </td>
                                </div>
                                <td mat-cell *matCellDef="let element" style="min-width: 180px; max-width: 200px">
                                  {{ element["Remark"] }}
                                </td>
                              </ng-container>
                              <tr class="odd" mat-header-row *matHeaderRowDef="displayedProductColumns"></tr>
                              <tr class="odd" mat-header-row *matHeaderRowDef="displayedFreightColumns"></tr>
                              <tr class="even" mat-header-row *matHeaderRowDef="displayedTotalColumns"></tr>
                              <tr mat-row *matRowDef="let row; columns: displayedProductColumns"></tr>
                            </table>
                            <div *ngIf="TotalProductRecord == 0" class="text-center">
                              No Record found.
                            </div>
                            <div *ngIf="TotalProductRecord > 0">
                              <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50, 100]"
                                [length]="totalProductSize" showFirstLastButtons
                                aria-label="Select page of periodic elements" [pageIndex]="currentPage"
                                (page)="ProducthandlePage($event)" [pageSize]="pageSize">
                              </mat-paginator>
                            </div>
                          </div>
                        </ng-template>
                      </ngb-tab>

                      <ngb-tab id="t2">
                        <ng-template ngbTabTitle>
                          <div (click)="tabclick2()"> Contact </div>
                        </ng-template>
                        <ng-template ngbTabContent>
                          <div class="table-responsive mt-3">
                            <mat-form-field class="example-full-width pb-0 w-100 form-control-design1" appearance="fill"
                              style="width: 250px !important; float: right">
                              <input #inputField matInput class="text-limit pos-search" [(ngModel)]="searchword_Con"
                                placeholder="Search" [ngModelOptions]="{ standalone: true }"
                                (keyup.enter)="ContactapplyFilter()" />
                              <span class="mdi mdi-magnify mdi-2x cursor-pointer" title="Search" style="
                                  position: absolute;
                                  right: 0;
                                  font-size: 20px;
                                  color: #999;
                                  top: 0;
                                " (click)="ContactapplyFilter()">
                              </span>
                              <span class="position-absolute"
                                style="top: 50%; right: 7%; transform: translate(-50%, -50%);" title="Clear">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                  class="bi bi-x" viewBox="0 0 16 16" (click)="clearContactData()"
                                  (clearEvent)="searchword=''" *ngIf="searchword_Con">
                                  <path
                                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                </svg>
                              </span>
                            </mat-form-field>
                            <table class="table" mat-table matSorts [dataSource]="ContactDataSource" matSort
                              [matSortActive]="'name'" [matSortDisableClear]="true" [matSortDirection]="'asc'"
                              [multiTemplateDataRows]="true" (matSortChange)="onContactSortData($event)"
                              aria-hidden="true">
                              <ng-container matColumnDef="CompanyType">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  Company Type<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort != 'CompanyType'" /><img src="assets/images/sort_up.png" alt=""
                                    *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'CompanyType'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'CompanyType'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element">
                                  {{ element["CompanyType"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="CompanyName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  Company Name<img src="assets/images/sort_both.png" *ngIf="columnsort != 'CompanyName'"
                                    alt="" /><img src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'CompanyName'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'CompanyName'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element">
                                  {{ element["CompanyName"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="City">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  City
                                  <img src="assets/images/sort_both.png" *ngIf="columnsort != 'City'" alt="" /><img
                                    src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'City'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'City'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element">
                                  {{ element["CityName"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="Country">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  Country
                                  <img src="assets/images/sort_both.png" *ngIf="columnsort != 'Country'" alt="" /><img
                                    src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'Country'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'Country'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element">
                                  {{ element["CountryName"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="Email">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  Email
                                  <img src="assets/images/sort_both.png" alt="" *ngIf="columnsort != 'Email'" /><img
                                    src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'Email'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'Email'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element">
                                  <a href="mailto:{{ element['Email'] }}">{{
                                    element["Email"]
                                    }}</a>
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="Mobile">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  Mobile
                                  <img src="assets/images/sort_both.png" alt="" *ngIf="columnsort != 'Mobile'" /><img
                                    src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'Mobile'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'Mobile'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element">
                                  {{ element["Mobile"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="Website">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  Website
                                  <img src="assets/images/sort_both.png" alt="" *ngIf="columnsort != 'Website'" /><img
                                    src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'Website'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'Website'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element">
                                  <a target="" href="javascript:void(0);" (click)="AddHttpfun(element.Website)">{{
                                    element["Website"] }}
                                  </a>
                                </td>
                              </ng-container>
                              <tr class="odd" mat-header-row *matHeaderRowDef="displayedContactColumns"></tr>
                              <tr mat-row *matRowDef="
                                  let row;
                                  columns: displayedContactColumns
                                "></tr>
                            </table>
                            <div *ngIf="TotalContactRecord == 0" class="text-center">
                              No Record found.
                            </div>
                            <div *ngIf="TotalContactRecord > 0">
                              <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50, 100]"
                                [length]="totalContactSize" showFirstLastButtons
                                aria-label="Select page of periodic elements" [pageIndex]="currentPage"
                                (page)="ContacthandlePage($event)" [pageSize]="pageSize">
                              </mat-paginator>
                            </div>
                          </div>
                        </ng-template>
                      </ngb-tab>

                      <ngb-tab id="t5">
                        <ng-template ngbTabTitle>
                          <div (click)="tabclick2()"> Inquiry Task </div>
                        </ng-template>
                        <ng-template ngbTabContent>
                          <div class="table-responsive mt-3">
                            <mat-form-field class="example-full-width pb-0 w-100 form-control-design1" appearance="fill"
                              style="width: 250px !important; float: right">
                              <input #inputField matInput class="text-limit pos-search" [(ngModel)]="searchword_task"
                                placeholder="Search" [ngModelOptions]="{ standalone: true }"
                                (keyup.enter)="TaskapplyFilter()" />
                              <span class="mdi mdi-magnify mdi-2x cursor-pointer" title="Search" style="
                                  position: absolute;
                                  right: 0;
                                  font-size: 20px;
                                  color: #999;
                                  top: 0;
                                " (click)="TaskapplyFilter()">
                              </span>
                              <span class="position-absolute"
                                style="top: 50%; right: 7%; transform: translate(-50%, -50%);" title="Clear">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                  class="bi bi-x" viewBox="0 0 16 16" (click)="clearTaskData()"
                                  (clearEvent)="searchword=''" *ngIf="searchword_task">
                                  <path
                                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                </svg>
                              </span>
                            </mat-form-field>
                            <table class="table" mat-table matSorts [dataSource]="TaskDataSource" matSort
                              [matSortActive]="'name'" [matSortDisableClear]="true" [matSortDirection]="'asc'"
                              [multiTemplateDataRows]="true" (matSortChange)="onTaskSortData($event)"
                              aria-hidden="true">
                              <ng-container matColumnDef="TaskId">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  Task Id<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort != 'TaskId'" /><img src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'TaskId'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'TaskId'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element">
                                  {{ element["TaskNumber"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="TaskTitle">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-nowrap">
                                  Task Title<img src="assets/images/sort_both.png" *ngIf="columnsort != 'TaskTitle'"
                                    alt="" /><img src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'TaskTitle'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'TaskTitle'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element">
                                  <div class="truncate_description w-100 overflow-hidden px-2 py-4">
                                    {{ element["TaskTitleName"] }}
                                  </div>
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="TaskDescription">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-nowrap1">
                                  Task Description<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort != 'TaskDescription'" alt="" /><img
                                    src="assets/images/sort_up.png" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'TaskDescription'
                                    " alt="" /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'TaskDescription'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element">
                                  <div class="truncate_description1 w-100 overflow-hidden px-2 py-4">
                                    {{ element["TaskDescription"] }}
                                  </div>
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="TaskStatus">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  Task Status<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort != 'TaskStatus'" /><img src="assets/images/sort_up.png" alt=""
                                    *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'TaskStatus'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'TaskStatus'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element">
                                  {{ element["TaskStatusName"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="TaskPriority">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  Task Priority<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort != 'TaskPriority'" /><img src="assets/images/sort_up.png" alt=""
                                    *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'TaskPriority'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'TaskPriority'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element">
                                  {{ element["TaskPriorityName"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="StartDate">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  Start Date<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort != 'StartDate'" /><img src="assets/images/sort_up.png" alt=""
                                    *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'StartDate'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'StartDate'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element">
                                  {{ element["StartDate"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="EndDate">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  End Date<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort != 'EndDate'" /><img src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'EndDate'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'EndDate'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element">
                                  {{ element["EndDate"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="AssignedTo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  Assigned To<img src="assets/images/sort_both.png" *ngIf="columnsort != 'AssignedTo'"
                                    alt="" /><img src="assets/images/sort_up.png" alt="" *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'AssignedTo'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'AssignedTo'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element">
                                  {{ element["AssignedToUserName"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="CreatedBy">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  Created By<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort != 'CreatedBy'" /><img src="assets/images/sort_up.png" alt=""
                                    *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'CreatedBy'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'CreatedBy'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element">
                                  {{ element["CreatedByUserName"] }}
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="CreatedDate">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                  Created Date<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort != 'CreatedDate'" /><img src="assets/images/sort_up.png" alt=""
                                    *ngIf="
                                      upicon &&
                                      !downicon &&
                                      columnsort == 'CreatedDate'
                                    " /><img src="assets/images/sort_down.png" alt="" *ngIf="
                                      downicon &&
                                      !upicon &&
                                      columnsort == 'CreatedDate'
                                    " />
                                </th>
                                <td mat-cell *matCellDef="let element">
                                  {{ element["CreatedDate"] }}
                                </td>
                              </ng-container>

                              <tr class="odd" mat-header-row *matHeaderRowDef="displayedTaskColumns"></tr>
                              <tr mat-row *matRowDef="
                                  let row;
                                  columns: displayedTaskColumns
                                "></tr>
                            </table>
                            <div *ngIf="TotalTaskRecord == 0" class="text-center">
                              No Record found.
                            </div>
                            <div *ngIf="TotalTaskRecord > 0">
                              <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50, 100]" [length]="totalTaskSize"
                                showFirstLastButtons aria-label="Select page of periodic elements"
                                [pageIndex]="currentPage" (page)="TaskhandlePage($event)" [pageSize]="pageSize">
                              </mat-paginator>
                            </div>
                          </div>
                        </ng-template>
                      </ngb-tab>

                      <ngb-tab id="t6">
                        <ng-template ngbTabTitle>
                          <div (click)="tabclick2()"> Activity History </div>
                        </ng-template>
                        <ng-template ngbTabContent>
                          <div class="activity-history mt-3">
                            <ul>
                              <li *ngFor="let detail of inquiryActivityHistory">
                                <div>
                                  <span><i class="fa fa-calendar-check-o"></i>
                                    {{ detail.CreatedDate }}</span>
                                  <i class="fa fa-user-circle"></i>{{ detail.userName }}
                                </div>
                                <p>{{ detail.Type }}</p>
                              </li>
                              <li *ngIf="inquiryActivityHistory == ''">
                                <div></div>
                                <p class="text-center">No Data Found</p>
                              </li>
                            </ul>
                          </div>
                          <div class="spinner-border" role="status" *ngIf="loader">
                            <span class="sr-only">Loading...</span>
                          </div>
                          <div class="text-center position-relative" *ngIf="showMore">
                            <a href="javascript:void(0);" (click)="showMoreactivity()"
                              class="read-more read-more-top new-show-less" placement="top">
                              <span>
                                <img src="{{ default }}" class="img-fluid" alt="..." width="21" />
                                Show More
                              </span>
                            </a>
                          </div>
                        </ng-template>
                      </ngb-tab>
                    </ngb-tabset>
                  </div>
                </div>
              </form>
            </ng-template>
          </ngb-tab>

          <ngb-tab id="t10">
            <ng-template ngbTabTitle>
              <div (click)="tabclick('t10')"> Inquiry Document </div>
            </ng-template>
            <ng-template ngbTabContent>
              <div class="row form-row">
                <div class="col-sm-12">
                  <h5 class="text-green mt-3">
                    Inquiry ID: {{ formdata.InquiryNumber }}
                  </h5>
                </div>
              </div>
              <div class="form-row mt-3">
                <table class="table table-striped" aria-hidden="true">
                  <thead>
                    <tr>
                      <th scope="col" style="width: 10%">
                        <b>Type of File</b>
                      </th>
                      <th scope="col"><b>Uploaded Document Name</b></th>
                      <th scope="col"><b>Action</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td *ngIf="UpDoc && UpDoc.InquiryReceivedCopy != ''">
                        <img src="{{ url + UpDoc.InquiryReceivedCopy }}" alt=""
                          class="img-thumbnail user-attachment-img" />
                      </td>
                      <td *ngIf="UpDoc && UpDoc.InquiryReceivedCopy == ''">
                        <img src="{{ dft_icn }}" alt="" class="img-thumbnail user-attachment-img" />
                      </td>
                      <td>Inquiry Received Copy</td>
                      <td>
                        <div class="d-flex"
                          *ngIf="UpDoc && UpDoc.InquiryReceivedCopy!='' && (permission.Inquiry_AttachmentDownload == 1 || userRId==1)">
                          <a href="javascript:void(0);"
                            class="btn bg-light-primary btn btn-circle align-items-center d-flex justify-content-center mr-1"
                            placement="bottom" ngbTooltip="Download"
                            (click)="downloadModal(downloadConfirm,'InquiryReceivedCopy',downloadurl+inquirydata.InquiryReceivedCopy)"><span
                              class="mdi mdi-download mdi-18px"></span></a>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td *ngIf="UpDoc && UpDoc.QuotationSentCopy != ''">
                        <img src="{{ url + UpDoc.QuotationSentCopy }}" alt=""
                          class="img-thumbnail user-attachment-img" />
                      </td>
                      <td *ngIf="UpDoc && UpDoc.QuotationSentCopy == ''">
                        <img src="{{ dft_icn }}" alt="" class="img-thumbnail user-attachment-img" />
                      </td>
                      <td>Quotation sent Copy</td>
                      <td>
                        <div class="d-flex"
                          *ngIf="UpDoc && UpDoc.QuotationSentCopy!='' && (permission.Inquiry_AttachmentDownload == 1 || userRId==1)">
                          <a href="javascript:void(0);"
                            class="btn bg-light-primary btn btn-circle align-items-center d-flex justify-content-center mr-1"
                            placement="bottom" ngbTooltip="Download"
                            (click)="downloadModal(downloadConfirm,'QuotationSentCopy',downloadurl+inquirydata.QuotationSentCopy)"><span
                              class="mdi mdi-download mdi-18px"></span></a>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td *ngIf="UpDoc && UpDoc.ProductImage != ''">
                        <img src="{{ url + UpDoc.ProductImage }}" alt="" class="img-thumbnail user-attachment-img" />
                      </td>
                      <td *ngIf="UpDoc && UpDoc.ProductImage == ''">
                        <img src="{{ dft_icn }}" alt="" class="img-thumbnail user-attachment-img" />
                      </td>
                      <td>Technical Data Sheets with Product image</td>
                      <td>
                        <div class="d-flex"
                          *ngIf="UpDoc && UpDoc.ProductImage!='' && (permission.Inquiry_AttachmentDownload == 1 || userRId==1)">
                          <a href="javascript:void(0);"
                            class="btn bg-light-primary btn btn-circle align-items-center d-flex justify-content-center mr-1"
                            placement="bottom" ngbTooltip="Download"
                            (click)="downloadModal(downloadConfirm,'ProductImage',downloadurl+inquirydata.ProductImage)"><span
                              class="mdi mdi-download mdi-18px"></span></a>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td *ngIf="UpDoc && UpDoc.FactoryBackupDocuments != ''">
                        <img src="{{ url + UpDoc.FactoryBackupDocuments }}" alt=""
                          class="img-thumbnail user-attachment-img" />
                      </td>
                      <td *ngIf="UpDoc && UpDoc.FactoryBackupDocuments == ''">
                        <img src="{{ dft_icn }}" alt="" class="img-thumbnail user-attachment-img" />
                      </td>
                      <td>Factory Backup Documents</td>
                      <td>
                        <div class="d-flex"
                          *ngIf="UpDoc && UpDoc.FactoryBackupDocuments!='' && (permission.Inquiry_AttachmentDownload == 1 || userRId==1)">
                          <a href="javascript:void(0);"
                            class="btn bg-light-primary btn btn-circle align-items-center d-flex justify-content-center mr-1"
                            placement="bottom" ngbTooltip="Download"
                            (click)="downloadModal(downloadConfirm,'FactoryBackupDocuments',downloadurl+inquirydata.FactoryBackupDocuments)"><span
                              class="mdi mdi-download mdi-18px"></span></a>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td *ngIf="UpDoc && UpDoc.CostingSheet != ''">
                        <img src="{{ url + UpDoc.CostingSheet }}" alt="" class="img-thumbnail user-attachment-img" />
                      </td>
                      <td *ngIf="UpDoc && UpDoc.CostingSheet == ''">
                        <img src="{{ dft_icn }}" alt="" class="img-thumbnail user-attachment-img" />
                      </td>
                      <td>Costing Sheet</td>
                      <td>
                        <div class="d-flex"
                          *ngIf="UpDoc && UpDoc.CostingSheet!='' && (permission.Inquiry_AttachmentDownload == 1 || userRId==1)">
                          <a href="javascript:void(0);"
                            class="btn bg-light-primary btn btn-circle align-items-center d-flex justify-content-center mr-1"
                            placement="bottom" ngbTooltip="Download"
                            (click)="downloadModal(downloadConfirm,'CostingSheet',downloadurl+inquirydata.CostingSheet)"><span
                              class="mdi mdi-download mdi-18px"></span></a>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td *ngIf="UpDoc && UpDoc.Other1 != ''">
                        <img src="{{ url + UpDoc.Other1 }}" alt="" class="img-thumbnail user-attachment-img" />
                      </td>
                      <td *ngIf="UpDoc && UpDoc.Other1 == ''">
                        <img src="{{ dft_icn }}" alt="" class="img-thumbnail user-attachment-img" />
                      </td>
                      <td>Other 1</td>
                      <td>
                        <div class="d-flex"
                          *ngIf="UpDoc && UpDoc.Other1!='' && (permission.Inquiry_AttachmentDownload == 1 || userRId==1)">
                          <a href="javascript:void(0);"
                            class="btn bg-light-primary btn btn-circle align-items-center d-flex justify-content-center mr-1"
                            placement="bottom" ngbTooltip="Download"
                            (click)="downloadModal(downloadConfirm,'Other1',downloadurl+inquirydata.Other1)"><span
                              class="mdi mdi-download mdi-18px"></span></a>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td *ngIf="UpDoc && UpDoc.Other2 != ''">
                        <img src="{{ url + UpDoc.Other2 }}" alt="" class="img-thumbnail user-attachment-img" />
                      </td>
                      <td *ngIf="UpDoc && UpDoc.Other2 == ''">
                        <img src="{{ dft_icn }}" alt="" class="img-thumbnail user-attachment-img" />
                      </td>
                      <td>Other 2</td>
                      <td>
                        <div class="d-flex"
                          *ngIf="UpDoc && UpDoc.Other2!='' && (permission.Inquiry_AttachmentDownload == 1 || userRId==1)">
                          <a href="javascript:void(0);"
                            class="btn bg-light-primary btn btn-circle align-items-center d-flex justify-content-center mr-1"
                            placement="bottom" ngbTooltip="Download"
                            (click)="downloadModal(downloadConfirm,'Other2',downloadurl+inquirydata.Other2)"><span
                              class="mdi mdi-download mdi-18px"></span></a>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-template>
          </ngb-tab>
        </ngb-tabset>
      </div>
    </div>
  </div>
</div>

<ng-template #downloadConfirm>
  <div class="modal-body text-center">
    <p>Do you want to Download {{filename}} ?</p>
    <button type="button" class="btn btn-info btn-sm" (click)="download(); modalRef.hide();"
      [disabled]="delNameDel">Download</button>
    <button type="button" class="btn btn-light btn-sm ml-2" (click)="decline()">Cancel</button>
  </div>
</ng-template>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>